module.exports = __webpack_public_path__ + "05_short_gold.a5101fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/05_short_gold.png
// module id = 76tD
// module chunks = 0